import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_all_services_admin, duplicate_service, update_service } from '../../api/servicesAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdCopyAll, MdEdit, MdMenuOpen, MdViewModule } from 'react-icons/md';
import { tidy_date, tidy_date_raw } from '../../utils/helper'
import { FaEye, FaOpenid } from 'react-icons/fa';
import notify from '../../utils/IANotification';
import DataTable from '../../components/ui/DataTable'
import FileUploadField from '../../components/FileUploadField'
import Button from '../../components/ui/Button'

export default function ServicesPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)
  const [serviceFilter, setServiceFilter] = useState([])
  const table_columns = [
    {
      header: "",
      accessor: "file_data.ext_file_path",
      modifier: (data, row) => <img src={data ? `${config.endpoint}${data}` : "/default/default.jpg"} alt="announcement" style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }} />
    },
    {
      header: "Name",
      accessor: "service_title"
    },
    {
      header: "Type",
      accessor: "service_type_ids",
      modifier: (data) => `${data?.length} services` || "N/A"
    },
    {
      header: "Sermon Title",
      accessor: "sermon_title",
      modifier: (data) => data || "N/A"
    },
    {
      header: "Bulletin",
      accessor: "bulletin_id",
      modifier: (data) => data ? "Yes" : "N/A"
    },
    {
      header: "Date & Time",
      accessor: "service_start_datetime",
      modifier: (value, row) => `${tidy_date(row.service_start_datetime)} - ${tidy_date(row.service_end_datetime)}`
    },
    {
      header: "Date Submitted",
      accessor: "createdAt",
      modifier: (data) => tidy_date(data)
    }
  ]

  useEffect(() => {
    fetchServices()
  }, [])

  const fetchServices = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_services_admin()
    if (!error && status === 200) {
      let service_data = data
      service_data.sort((a, b) => {
        return new Date(b.service_start_datetime) - new Date(a.service_start_datetime)
      })
      setServices(service_data)

      let temp = []
      for (let i = 0; i < service_data.length; i++) {
        let service_type = service_data[i].service_type.name
        if (!temp.includes(service_type)) {
          temp.push(service_type)
        }
      }
      setServiceFilter(temp)
    }
    setLoading(false)
  }


  const duplicateService = async (service_id) => {
    const { data, error, message, status } = await duplicate_service({ service_id })
    if (!error && status === 200) {
      fetchServices()
      notify({ message: 'Service duplicated', type: 'success' })
    } else {
      notify({ message: 'Failed to duplicate service', type: 'error' })
    }
  }

  // Selection state for bulk actions
  const [selectedRows, setSelectedRows] = useState([])
  const [showUploadModal, setShowUploadModal] = useState(false)

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      const exists = prev.includes(id)
      if (exists) return prev.filter((v) => v !== id)
      return [...prev, id]
    })
  }

  const handleSelectionAction = async ({ action, selected }) => {
    if (!action) return
    if (action === 'upload-image') {
      // open modal to upload image for selected services
      setShowUploadModal(true)
    }
  }


  return (
    <AdminLayout
      navSelected={"Services"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Services</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/services/details?service_id=new")
            }}
          >
            <MdAdd size={16} />
            New Service
          </button>
        </>
      }
    >
      <div className="column items-center justify-between w-100 mb-2">
        {/* <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        /> */}
        {/* <div className="flex-row flex gap-2 alignEnd w-100 mt-10">
          <select
            className="select-input-chip"
            value={selectedService}
            onChange={(e) => {
              setSelectedService(e.target.value)
            }}
          >
            <option value="all">All Service Types</option>
            {serviceFilter.map((service, index) => {
              return (
                <option key={index} value={service}>
                  {service}
                </option>
              )
            })}
          </select>

          <select
            className="select-input-chip"
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value)
            }}
          >
            <option value="all">All Service</option>
            <option value="past">Past</option>
            <option value="upcoming">Upcoming</option>
          </select>
      </div> */}
      </div>

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          <DataTable
            columns={table_columns}
            data={services}
            enableActions
            enablePagination
            enableSelection
            accessorKey={'id'}
            selectedRows={selectedRows}
            onRowSelect={handleRowSelect}
            onSelectionChange={handleSelectionAction}
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdCopyAll} onClick={() => duplicateService(row.id)}>
                    Duplicate
                  </Button>
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/services/details?service_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />

          {showUploadModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white p-4 rounded w-[600px]">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-semibold">Upload image for selected services</h3>
                  <button className="text-sm text-gray-600" onClick={() => setShowUploadModal(false)}>Close</button>
                </div>
                <FileUploadField
                  item_index={"services-upload"}
                  max_file_size={5}
                  max_files={1}
                  upload_url={`${config.endpoint}/file/services/id/bulk`}
                  additional_payload={
                    { service_ids: selectedRows }
                  }
                  onChange={(files) => {
                    fetchServices()
                    setShowUploadModal(false)
                    setSelectedRows([])
                  }}
                />
              </div>
            </div>
          )}
          {/* <pre>{JSON.stringify(services, null, 2)}</pre> */}
          {/* {services.map((service, index) => {
            if (!JSON.stringify(service)?.toLowerCase().includes(query.toLowerCase())) return null
            if (selectedService !== "all" && service?.service_type?.name !== selectedService) return null
            if (selectedStatus === "past" && new Date(service?.service_end_datetime) > new Date()) return null
            if (selectedStatus === "upcoming" && new Date(service?.service_end_datetime) < new Date()) return null

            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">
                  <p className='small'>{tidy_date_raw(service?.service_start_datetime)?.day} {tidy_date_raw(service?.service_start_datetime)?.month} {tidy_date_raw(service?.service_start_datetime)?.year}</p>
                  <h3>{service.service_title}</h3>
                  <h3 className='card-subtitle'>{tidy_date_raw(service?.service_start_datetime)?.hour}:{tidy_date_raw(service?.service_start_datetime)?.minute} - {tidy_date_raw(service?.service_end_datetime)?.hour}:{tidy_date_raw(service?.service_end_datetime)?.minute} • {service?.service_type_ids?.length || 0} Services • {service?.sermon_title}</h3>
                </div>
                <div className="flex-row flex gap-30 items-center">
                  <button
                    className="backgroundLess row gap-2 items-center"
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      duplicateService(service.id)
                    }}
                  >
                    Duplicate
                  </button>
                  <button
                    className="backgroundLess row gap-2 items-center"
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      navigate("/admin/services/details?service_id=" + service.id)
                    }}
                  >
                    View
                  </button>
                </div>
              </div>
            )
          })} */}
        </div>
      )}
    </AdminLayout>
  )
}
